import React from 'react'
import ProjectenNew from '../components/Projecten/ProjectenNew';

const Projecten = () => {
  return (
    <div>
      <ProjectenNew />
    </div>
  )
}

export default Projecten
